import withAdminLayout from "components/HoC/withAdminLayout";
import AllDocumentPage from "pages/admin/smart-visa/AllDocumentPage";
import AppointmentPage from "pages/admin/smart-visa/AppointmentPage";
import ConsiderationResult from "pages/admin/smart-visa/ConsiderationResult";
import DocumentDetailPage from "pages/admin/smart-visa/DocumentDetailPage";
import React from "react";
import { useTranslation } from "react-i18next";
import { Route, Switch } from "react-router-dom";
import CancelDetailPage from "pages/admin/smart-visa/CancelDetailPage";
import StatusReportDetailPage from "pages/admin/smart-visa/StatusReportDetailPage";
import AppointmentDetailPage from "pages/admin/smart-visa/AppointmentDetailPage";

function SmartVisaPage() {
  const { t, i18n } = useTranslation();

  return (
    <Switch>
      <Route path="/admin/smart-visa/all-documents">
        <AllDocumentPage />
      </Route>
      <Route path="/admin/smart-visa/issuance-appointment">
        <AppointmentPage />
      </Route>
      <Route path="/admin/smart-visa/consideration-result">
        <ConsiderationResult />
      </Route>
      <Route path="/admin/smart-visa/document/:draftId">
        <DocumentDetailPage />
      </Route>


      <Route path="/admin/smart-visa/cancel-visa/:personal">
        <CancelDetailPage />
      </Route>
      <Route path="/admin/smart-visa/status-report/:personal">
        <StatusReportDetailPage />
      </Route>

      <Route path="/admin/smart-visa/appointment/:draftId">
        <AppointmentDetailPage />
      </Route>

    </Switch>
  );
}

export default withAdminLayout(SmartVisaPage);
